import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import { breadCrumbsState } from "../../../store/layout";
import startUpper from "../../../utils/start-upper";

export const useSetCaseBreadcrumbs = (caseId: string) => {
	const setBreadCrumbs = useSetRecoilState(breadCrumbsState);
	const { t } = useTranslation();

	useEffect(() => {
		setBreadCrumbs({
			fromProps: true,
			links: [
				{ label: startUpper(t("cases")), link: "/cases" },
				{ label: caseId || "", link: undefined },
			],
		});
		return () => setBreadCrumbs(null);
	}, []);
};
